import React, { useState, useCallback, useMemo, useEffect } from "react";
import { debounce } from "lodash";
import search_icon from "../../assets/icons/search.svg";
import go_back from "../../assets/icons/goBack.svg";

import "./catalog.css";
import {
  atlasSearchByCategory,
  productDetail,
} from "../../redux/Catalog/catalogActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearSearchProducts } from "../../redux/Catalog/catalog";
import {
  FourLayout,
  OneLayout,
  ThreeLayout,
  TwoLayout,
} from "../../containers/catalogue/CatalogueLayout/ImageLayout.js";
import { CatalogueLayout } from "../../components/Layout/cardLayout.js";
import {
  CategoryOne,
  CategoryTwo,
  CategoryThree,
  CategoryFour,
  CategoryFive,
} from "../../containers/catalogue/CatalogueLayout/DetailsLayout.js";
import AddProducts from "./addProducts.js";
import Atlas from "../../containers/catalogue/atlas/atlas.js";
import { Edit } from "@mui/icons-material";
import { hasPermission } from "../../utils/permissionChecker.js";
import { PRIVILEGES } from "../../utils/privileges.js";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const ProductCatalogPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, groupByResult, products, productsLoading } = useSelector(
    (state) => state.catalog
  );
  const { user } = useSelector((state) => state.auth);

  const [chipId, setChip] = useState({
    slug: "crop-input",
  });

  const [selectedCategory, setSelectedCategory] = React.useState("");
  const [searchValue, setSearchValue] = useState("");
  const [isPageOpen, setPageOpen] = useState(true);
  const [productInfo, setProductInfo] = useState({});
  const [isClickCategory, setIsClickCategory] = React.useState(false);
  const [productsInfoLoading, setProductInfoLoading] = useState(false);

  const handleBack = () => {
    setPageOpen(true);
  };

  const toggleChip = (val) => {
    setChip(val);
    setSelectedCategory(false);
    setIsClickCategory(false);
    if (val.slug === "mechanisation") {
      setSelectedCategory({ id: 30 });
      setIsClickCategory(true);
    }
  };

  const handleSearch = useMemo(
    () =>
      debounce((val) => {
        setPageOpen(true);
        dispatch(atlasSearchByCategory({ search: val, type: chipId.slug }));
      }, 750),
    [dispatch, chipId.slug]
  );

  const handleChange = useCallback(
    (e) => {
      let val = e.target.value;
      setSearchValue(val);
      handleSearch(val);
    },
    [handleSearch]
  );

  const handleViewProduct = (item) => {
    setProductInfoLoading(true);
    setPageOpen(false);
    dispatch(productDetail({ id: item.id })).then((res) => {
      if (res.type === "productDetail/fulfilled") {
        setProductInfoLoading(false);
        const response = res?.payload?.data;
        setProductInfo(response);
      } else if (res.type === "productDetail/rejected") {
        setProductInfoLoading(false);
        setProductInfo({});
      }
    });
  };

  useEffect(() => {
    dispatch(clearSearchProducts());

    if (searchValue) {
      const debounceTimer = setTimeout(() => {
        dispatch(
          atlasSearchByCategory({
            type: chipId.slug,
            search: searchValue,
          })
        );
      }, 750);

      return () => clearTimeout(debounceTimer);
    } else {
      dispatch(
        atlasSearchByCategory({
          type: chipId.slug,
        })
      );
    }
  }, [dispatch, chipId.slug, searchValue]);

  return (
    <>
      <div className="bg-white rounded-[8px] px-4 py-3 flex justify-between items-center">
        <div>
          <h6 className="text-[#2B8C34] font-semibold text-lg">
            Product Catalogue
          </h6>
        </div>
        <div>
          {hasPermission(user, PRIVILEGES.ADD_PRODUCT) && <AddProducts />}
        </div>
      </div>

      <div className="bg-white rounded-lg pb-5 mt-4">
        <div className="px-4 py-3">
          <p className="text-[#4B564D] text-sm font-semibold">Atlas</p>
        </div>

        {isPageOpen && (
          <div className="mt-0 px-4 border-y border-y-[#E1E6E1] py-3">
            <div className="relative ">
              <input
                type="text"
                onChange={handleChange}
                value={searchValue}
                className="appearance-none w-full placeholder:text-[#96A397] 
                          placeholder:text-sm text-[#344335] text-base focus:border-[#2B8C34] 
                          focus:outline-none focus:shadow-input rounded-lg border h-[44px] border-[#E1E6E1] bg-white py-3 px-10"
                placeholder="Search for products, crops"
              />
              <img
                src={search_icon}
                alt="search"
                className="absolute top-1/2 transform -translate-y-1/2 left-4 cursor-pointer"
              />
            </div>

            {/* chips */}
            {isPageOpen && (
              <ul className="mt-4 flex  rounded-lg border border-[#E1E6E1] bg-[#F6F7F6] w-fit pr-3">
                {products?.product_type_counts?.map((val) => (
                  <div className="flex gap-1  items-center">
                    <div
                      key={val.id}
                      onClick={() => toggleChip(val)}
                      className={
                        chipId.slug === val.slug
                          ? "bg-[#FFFFFF] px-3 py-[6px] rounded-lg cursor-pointer flex items-center gap-1"
                          : "bg-[#F6F7F6] px-3 py-[6px] rounded-lg cursor-pointer flex items-center gap-1"
                      }
                    >
                      <p
                        className={
                          chipId.slug === val.slug
                            ? " text-[#161D17] text-sm font-semibold"
                            : " text-[#5F6D60] text-sm font-semibold"
                        }
                      >
                        {" "}
                        {val.name}{" "}
                      </p>
                      <div
                        className={
                          chipId.slug === val.slug
                            ? "border border-[#DBFFDF] bg-[#DBFFDF] text-xs text-primary font-semibold px-1 flex items-center justify-center h-5 rounded-[4px] w-fit"
                            : "border border-[#5C715E] text-xs text-[#5C715E] font-semibold px-1 h-5 flex items-center justify-center rounded-[4px] w-fit"
                        }
                      >
                        {val.count}
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            )}
          </div>
        )}

        {!isPageOpen && <div className="border-t border-y-[#E1E6E1]" />}

        <div>
          {/* Categories */}
          <Atlas
            isPageOpen={isPageOpen}
            chipId={chipId}
            categories={products.categories}
            products={products.products}
            setSelectedCategory={setSelectedCategory}
            selectedCategory={selectedCategory}
            loading={productsLoading}
            chip={chipId}
            setIsClickCategory={setIsClickCategory}
            isClickCategory={isClickCategory}
            searchValue={searchValue}
            informationCard={products.information_card}
            onClick={handleViewProduct}
          />

          {loading &&
            ["1", "2", "3", "4", "5"]?.map((data, index) => (
              <div className="animate-pulse w-full mt-4 px-4" key={index}>
                <div className="h-2 bg-gray-200 rounded-lg w-full mb-2"></div>
                <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              </div>
            ))}

          {/* ---------------------------------------- first section ------------------- */}
          {isPageOpen && (
            <div className="mt-4 px-4">
              {/* ---Crop products map */}
              <div className="mb-3">
                {groupByResult && groupByResult.InputProducts ? (
                  groupByResult.InputProducts.length > 0 ? (
                    <h5 className="text-[#344335] text-sm font-semibold">
                      Crop
                    </h5>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {groupByResult && groupByResult.InputProducts
                  ? groupByResult.InputProducts.length > 0
                    ? groupByResult.InputProducts?.map((item, index) => (
                        <div
                          key={index}
                          className="mt-1 ml-2 product hover:bg-[#EDF7EE] flex justify-between items-center hover:rounded-[4px] transition-all py-2 px-3 cursor-pointer"
                        >
                          <div>
                            <h4 className="text-[#344335] text-sm font-semibold">
                              {item.product_details
                                ? item.product_details.name
                                : "N/A"}
                            </h4>

                            <div className="flex gap-2 mt-1 text-[#5C715E] font-medium text-xs">
                              <p>
                                {item.vendor_price_details
                                  ? item.vendor_price_details.vendor_name
                                  : ""}
                              </p>
                              <p>|</p>
                              <p>
                                <i className="mdi mdi-currency-ngn"></i>
                                {item.product_details.display_price}/
                                {item.product_details.product_size}
                                {item.product_details.measurement}
                              </p>
                            </div>
                          </div>
                          <div>
                            <button
                              onClick={() =>
                                handleViewProduct(
                                  item.product_details.product_type,
                                  item.vendor_price_details.product_id
                                )
                              }
                              className="text-primary ctaView
                                          text-xs font-medium"
                            >
                              View Product
                            </button>
                          </div>
                        </div>
                      ))
                    : ""
                  : ""}
              </div>

              {/* --- Livestock products */}
              <div className="mb-3">
                {groupByResult && groupByResult.LivestockInputs ? (
                  groupByResult.LivestockInputs.length > 0 ? (
                    <h5 className="text-[#344335] text-sm font-semibold">
                      Livestock
                    </h5>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {groupByResult && groupByResult.LivestockInputs
                  ? groupByResult.LivestockInputs.length > 0
                    ? groupByResult.LivestockInputs?.map((item, index) => (
                        <div
                          key={index}
                          className="mt-1 ml-2 product hover:bg-[#EDF7EE] flex justify-between items-center hover:rounded-[4px] transition-all py-2 px-3 cursor-pointer"
                        >
                          <div>
                            <h4 className="text-[#344335] text-sm font-semibold">
                              {item.product_details
                                ? item.product_details.name
                                : "N/A"}
                            </h4>

                            <div className="flex gap-2 mt-1 text-[#5C715E] font-medium text-xs">
                              <p>
                                {item.vendor_price_details
                                  ? item.vendor_price_details.vendor_name
                                  : ""}
                              </p>
                              <p>|</p>
                              <p>
                                <i className="mdi mdi-currency-ngn"></i>
                                {item.product_details.display_price}/
                                {item.product_details.product_size}
                                {item.product_details.measurement}
                              </p>
                            </div>
                          </div>
                          <div>
                            <button
                              onClick={() =>
                                handleViewProduct(
                                  item.product_details.product_type,
                                  item.vendor_price_details.product_id
                                )
                              }
                              className="text-primary ctaView
                                          text-xs font-medium"
                            >
                              View Product
                            </button>
                          </div>
                        </div>
                      ))
                    : ""
                  : ""}
              </div>

              {/* Advisory products */}
              <div className="mb-3">
                {groupByResult && groupByResult.AdvisoryProducts ? (
                  groupByResult.AdvisoryProducts.length > 0 ? (
                    <h5 className="text-[#344335] text-sm font-semibold">
                      Advisory
                    </h5>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {groupByResult && groupByResult.AdvisoryProducts
                  ? groupByResult.AdvisoryProducts.length > 0
                    ? groupByResult.AdvisoryProducts?.map((item, index) => (
                        <div
                          key={index}
                          className="mt-1 ml-2 product hover:bg-[#EDF7EE] flex justify-between items-center hover:rounded-[4px] transition-all py-2 px-3 cursor-pointer"
                        >
                          <div>
                            <h4 className="text-[#344335] text-sm font-semibold">
                              {item.product_details
                                ? item.product_details.name
                                : "N/A"}
                            </h4>

                            <div className="flex gap-2 mt-1 text-[#5C715E] font-medium text-xs">
                              <p>{item.vendor_price_details.vendor_name}</p>
                              <p>|</p>
                              <p>
                                <i className="mdi mdi-currency-ngn"></i>
                                {item.product_details.display_price}/
                                {item.product_details.product_size}
                                {item.product_details.measurement}
                              </p>
                            </div>
                          </div>
                          <div>
                            <button
                              onClick={() =>
                                handleViewProduct(
                                  item.product_details.product_type,
                                  item.vendor_price_details.product_id
                                )
                              }
                              className="text-primary ctaView
                                          text-xs font-medium"
                            >
                              View Product
                            </button>
                          </div>
                        </div>
                      ))
                    : ""
                  : ""}
              </div>

              {/* Mechanization */}
              <div className="mb-3">
                {groupByResult && groupByResult.MechanizationProducts ? (
                  groupByResult.MechanizationProducts.length > 0 ? (
                    <h5 className="text-[#344335] text-sm font-semibold">
                      Mechanization
                    </h5>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {groupByResult && groupByResult.MechanizationProducts
                  ? groupByResult.MechanizationProducts.length > 0
                    ? groupByResult.MechanizationProducts?.map(
                        (item, index) => (
                          <div
                            key={index}
                            className="mt-1 ml-2 product hover:bg-[#EDF7EE] flex justify-between items-center hover:rounded-[4px] transition-all py-2 px-3 cursor-pointer"
                          >
                            <div>
                              <h4 className="text-[#344335] text-sm font-semibold">
                                {item.product_details
                                  ? item.product_details.name
                                  : "N/A"}
                              </h4>

                              <div className="flex gap-2 mt-1 text-[#5C715E] font-medium text-xs">
                                <p>{item.vendor_price_details.vendor_name}</p>
                                <p>|</p>
                                <p>
                                  <i className="mdi mdi-currency-ngn"></i>
                                  {item.product_details.display_price}/
                                  {item.product_details.product_size}
                                  {item.product_details.measurement}
                                </p>
                              </div>
                            </div>
                            <div>
                              <button
                                onClick={() =>
                                  handleViewProduct(
                                    item.product_details.product_type,
                                    item.vendor_price_details.product_id
                                  )
                                }
                                className="text-primary ctaView
                                          text-xs font-medium"
                              >
                                View Product
                              </button>
                            </div>
                          </div>
                        )
                      )
                    : ""
                  : ""}
              </div>

              {/* Insurance */}
              <div className="mb-3">
                {groupByResult && groupByResult.InsuranceProducts ? (
                  groupByResult.InsuranceProducts.length > 0 ? (
                    <h5 className="text-[#344335] text-sm font-semibold">
                      Insurance
                    </h5>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {groupByResult && groupByResult.InsuranceProducts
                  ? groupByResult.InsuranceProducts.length > 0
                    ? groupByResult.InsuranceProducts?.map((item, index) => (
                        <div
                          key={index}
                          className="mt-1 ml-2 product hover:bg-[#EDF7EE] flex justify-between items-center hover:rounded-[4px] transition-all py-2 px-3 cursor-pointer"
                        >
                          <div>
                            <h4 className="text-[#344335] text-sm font-semibold">
                              {item.product_details
                                ? item.product_details.name
                                : "N/A"}
                            </h4>

                            <div className="flex gap-2 mt-1 text-[#5C715E] font-medium text-xs">
                              <p>{item.vendor_price_details.vendor_name}</p>
                              <p>|</p>
                              <p>
                                <i className="mdi mdi-currency-ngn"></i>
                                {item.product_details.display_price}/
                                {item.product_details.product_size}
                                {item.product_details.measurement}
                              </p>
                            </div>
                          </div>
                          <div>
                            <button
                              onClick={() =>
                                handleViewProduct(
                                  item.product_details.product_type,
                                  item.vendor_price_details.product_id
                                )
                              }
                              className="text-primary ctaView
                                          text-xs font-medium"
                            >
                              View Product
                            </button>
                          </div>
                        </div>
                      ))
                    : ""
                  : ""}
              </div>
            </div>
          )}

          {/* ---------------- Second Section ------------------------------------------------- */}
          {/* GO BACK SECTION */}
          {!isPageOpen && (
            <>
              {productsInfoLoading ? (
                <div className="w-full flex justify-center items-center text-center h-[500px]">
                  <p className="text-[#4B564D] font-semibold text-sm w-full mb-2 px-4 ">
                    Loading...
                  </p>
                </div>
              ) : (
                <div>
                  <div className="flex justify-between gap-2 border-b border-b-[#E1E6E1]">
                    <div
                      className=" px-4 py-3 flex flex-col gap-2 mt-1 mx-0"
                      style={{ marginLeft: 0, marginRight: 0 }}
                    >
                      <div
                        onClick={handleBack}
                        className="flex items-center cursor-pointer mt-0"
                      >
                        <img
                          src={go_back}
                          alt="go back"
                          className="w-[20px] h-[20px]"
                        />
                        <p className="text-sm font-semibold text-[#5C715E] ml-[4px] ">
                          Go Back
                        </p>
                      </div>

                      <div className="border border-[#E1E6E1]  rounded-md px-1 py-[2px] w-fit">
                        <p className="text-[#5F6D60] text-sm font-semibold">
                          {productInfo?.product_category?.name || "N/A"}{" "}
                        </p>
                      </div>

                      <p className="text-[#344335] text-2xl font-semibold">
                        {productInfo.product_name || "N/A"}{" "}
                      </p>
                    </div>

                    <div
                      onClick={() =>
                        navigate(`/edit-product/${productInfo.id}`)
                      }
                      className="border px-2 py-1 border-[#5F6D60] rounded-lg flex items-center gap-1 bg-white h-fit w-fit cursor-pointer  mt-2 mr-2 hover:bg-[#F6F7F6] transition-all"
                    >
                      <Edit style={{ color: "#5F6D60", fontSize: "16px" }} />
                      <p className="text-[#5F6D60] text-sm font-semibold">
                        Edit
                      </p>
                    </div>
                  </div>

                  {/* ------------------ LAYOUT ----------- */}
                  <div>
                    {productInfo?.images?.length === 1 ? (
                      <OneLayout image={productInfo?.images[0]} />
                    ) : productInfo.images?.length === 2 ? (
                      <TwoLayout images={productInfo.images} />
                    ) : productInfo.images?.length === 3 ? (
                      <ThreeLayout images={productInfo.images} />
                    ) : productInfo.images?.length >= 4 ? (
                      <FourLayout images={productInfo.images} />
                    ) : null}
                  </div>

                  <div className="flex gap-3 h-full">
                    {/* ------------------ DESCRIPTION ----------- */}
                    <div className="px-4 mt-6 w-1/2">
                      <CatalogueLayout
                        title="Product Description"
                        description={productInfo.product_description || "N/A"}
                      />
                    </div>

                    {/* ------------------ PRODUCT PROPERTY ----------- */}
                    <div className=" mt-6 w-1/2">
                      <CatalogueLayout
                        title="Product Variants"
                        description={
                          <div className="flex flex-col flex-wrap gap-3 px-[-20px]">
                            {productInfo?.variants?.length > 0 ? (
                              productInfo?.variants?.map((variant, index) => (
                                <div
                                  className={` ${
                                    productInfo?.variants?.length === index + 1
                                      ? " "
                                      : "border-b border-b-[#E1E6E1]  py-1"
                                  }`}
                                >
                                  {variant.variant_data?.images?.length > 1 && (
                                    <div className="flex items-center flex-wrap mb-1 ">
                                      {variant.variant_data?.images?.map(
                                        (imageUrl, imgIndex) => (
                                          <div key={imgIndex}>
                                            <Zoom>
                                              <div className="w-8 h-8 flex items-center justify-center border border-[#E1E6E1] rounded overflow-hidden bg-[#F8F9F8]">
                                                <img
                                                  src={imageUrl}
                                                  alt={`variant preview ${
                                                    index + 1
                                                  }`}
                                                  className="object-cover w-full h-full"
                                                />
                                              </div>
                                            </Zoom>
                                          </div>
                                        )
                                      ) || null}
                                    </div>
                                  )}

                                  <div
                                    key={index}
                                    className=" flex flex-row  gap-1 items-center"
                                  >
                                    <>
                                      {variant.variant_data?.images?.length <=
                                        1 && (
                                        <div className="flex items-center mb-1 ">
                                          {variant.variant_data?.images?.map(
                                            (imageUrl, imgIndex) => (
                                              <div key={imgIndex}>
                                                <Zoom>
                                                  <div className="w-8 h-8 flex items-center justify-center border border-[#E1E6E1] rounded overflow-hidden bg-[#F8F9F8]">
                                                    <img
                                                      src={imageUrl}
                                                      alt={`variant preview ${
                                                        index + 1
                                                      }`}
                                                      className="object-cover w-full h-full"
                                                    />
                                                  </div>
                                                </Zoom>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}
                                    </>
                                    {/* Always show type first */}
                                    <div className=" rounded-[4px] px-1 bg-white py-[2px] border border-[#E1E6E1]">
                                      <p className="text-[#5F6D60]  text-sm font-semibold">
                                        {variant.variant_data.type}
                                      </p>
                                    </div>
                                    <div className=" px-1 bg-white py-[2px]">
                                      <p className="text-[#5F6D60]  text-sm font-bold">
                                        /
                                      </p>
                                    </div>

                                    {/* Show value and unit together */}
                                    <div className=" rounded-[4px] px-1 bg-white py-[2px] border border-[#E1E6E1]">
                                      <p className="text-[#5F6D60]  text-sm font-semibold">
                                        {variant.variant_data.value}{" "}
                                        {variant.variant_data.unit}
                                      </p>
                                    </div>

                                    {/* Handle dynamic keys (excluding type, value, unit, image) */}
                                    {Object.entries(variant.variant_data)
                                      .filter(
                                        ([key]) =>
                                          ![
                                            "type",
                                            "value",
                                            "unit",
                                            "images",
                                          ].includes(key)
                                      )
                                      .map(([key, value], dynamicIndex) => (
                                        <React.Fragment
                                          key={`${key}-${dynamicIndex}`}
                                        >
                                          <div className=" px-1 bg-white py-[2px]">
                                            <p className="text-[#5F6D60]  text-sm font-bold">
                                              /
                                            </p>
                                          </div>
                                          <div className=" rounded-[4px] px-1 bg-white py-[2px] border border-[#E1E6E1]">
                                            <p className="text-[#5F6D60]  text-sm font-semibold">
                                              {value}
                                            </p>
                                          </div>
                                        </React.Fragment>
                                      ))}

                                    {/* Separator line between variants */}
                                    {/* {productInfo?.variants?.length ===
                                index + 1 ? null : (
                                  <div className="h-[20px] w-[1.5px] bg-[#96A397] ml-2" />
                                )} */}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="text-[#5C715E] text-sm font-medium">
                                No variants available
                              </p>
                            )}
                          </div>
                        }
                      />
                    </div>
                  </div>

                  {/* ------------------ CATEGORY COMPONENTS ----------- */}
                  <div className="px-4 mt-6">
                    {productInfo?.product_category?.name === "Bird Repellant" ||
                    productInfo?.product_category?.name === "Storage Product" ||
                    productInfo?.product_category?.name === "Rodenticide" ||
                    productInfo?.product_category?.name === "Nematicide" ? (
                      <CategoryTwo data={productInfo?.product_details} />
                    ) : null}

                    {productInfo?.product_category?.name === "Herbicide" ||
                    productInfo?.product_category?.name === "Insecticide" ||
                    productInfo?.product_category?.name ===
                      "Plant Growth Regulator Solution" ||
                    productInfo?.product_category?.name === "Fungicide" ? (
                      <CategoryOne data={productInfo?.product_details} />
                    ) : null}

                    {productInfo?.product_category?.name === "Fertilizers" ? (
                      <CategoryThree data={productInfo?.product_details} />
                    ) : null}

                    {productInfo?.product_category?.name === "Seed Dressing" ? (
                      <CategoryFour data={productInfo?.product_details} />
                    ) : null}

                    {productInfo?.product_category?.name === "Seed" ? (
                      <CategoryFive data={productInfo?.product_details} />
                    ) : null}

                    {/* Default fallback component */}
                    {!productInfo?.product_category?.name ||
                    (productInfo?.product_category?.name !== "Bird Repellant" &&
                      productInfo?.product_category?.name !==
                        "Storage Product" &&
                      productInfo?.product_category?.name !== "Rodenticide" &&
                      productInfo?.product_category?.name !== "Nematicide" &&
                      productInfo?.product_category?.name !== "Herbicide" &&
                      productInfo?.product_category?.name !== "Insecticide" &&
                      productInfo?.product_category?.name !==
                        "Plant Growth Regulator Solution" &&
                      productInfo?.product_category?.name !== "Fungicide" &&
                      productInfo?.product_category?.name !== "Fertilizers" &&
                      productInfo?.product_category?.name !== "Seed Dressing" &&
                      productInfo?.product_category?.name !== "Seed") ? (
                      <CategoryFive data={productInfo?.product_details} />
                    ) : null}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductCatalogPage;
